import type { ThemeWithoutTokens } from '../theme.types';

export const headerNavIconTokens = (theme: ThemeWithoutTokens) =>
  ({
    headerNavIconRadius: '50%',
    headerNavIconPaddingX: theme.space.component.x.xs,
    headerNavIconPaddingY: theme.space.component.y.xs,
  }) as const;
